import { render, staticRenderFns } from "./MessageStep.vue?vue&type=template&id=50be4b96&scoped=true&"
import script from "./MessageStep.vue?vue&type=script&lang=js&"
export * from "./MessageStep.vue?vue&type=script&lang=js&"
import style0 from "./MessageStep.vue?vue&type=style&index=0&id=50be4b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be4b96",
  null
  
)

export default component.exports